import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; //npm install jwt-decode


const ZtudiaAuthInterceptor = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // 1. Buscamos el parámetro ?shp= en la URL
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('shp');

        if (token) {
            try {
                // 2. Decodificamos el token para leer los datos del alumno
                const decodedData = jwtDecode(token);

                // IMPORTANTE: Un JWT tiene fecha de expiración (exp).
                // Validamos que el enlace no haya caducado (tus 2 minutos de C#).
                const currentTime = Date.now() / 1000; //1000; PRUEBAS: 1000000
                if (decodedData.exp < currentTime) {
                    alert("El enlace ha caducado. Por favor, vuelve a entrar desde Ztudia.");
                    window.location.href = `${process.env.REACT_APP_ZTUDIA_URL}`; // O tu URL real
                    return;
                }

                // 3. Extraemos los 'claims' que mandaste desde C#
                const studentProfile = {
                    username: decodedData.username,
                    nickname: decodedData.nickname,
                    centerId: parseInt(decodedData.centerId, 10),
                    centerName: decodedData.centerName,
                    email: decodedData.email
                };

                // 4. Guardamos en sesión para que los juegos sepan quién está jugando
                sessionStorage.setItem('arcade_session', JSON.stringify(studentProfile));
                sessionStorage.setItem('arcade_token', token); // Por si ocupas mandar peticiones al C# después

                // 5. Borramos el token de la URL visualmente (por limpieza) y mandamos al Lobby
                navigate('/ztudia/lobby', { replace: true });

            } catch (error) {
                console.error("Error validando el acceso:", error);
                alert("Acceso inválido.");
            }
        } else {
            // Si alguien entra directo a "/ztudia/" sin token, revisamos si ya tiene sesión.
            const existingSession = sessionStorage.getItem('arcade_session');
            if (existingSession) {
                navigate('/ztudia/lobby', { replace: true });
            } else {
                // Si no hay token ni sesión, lo mandamos de regreso a Ztudia
                window.location.href = `${process.env.REACT_APP_ZTUDIA_URL}`;
            }
        }
    }, [navigate, location.search]);

    return (
        <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#111', color: 'white' }}>
            <h2>Verificando acceso seguro...</h2>
        </div>
    );
};

export { ZtudiaAuthInterceptor };